module.exports = __webpack_public_path__ + "static/img/head_7.bb3e7355.png";